import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT } from "@/data/content";
import { useSeo } from "@/lib/seo";

export const LegalPage = ({ doc }) => {
  useSeo({ title: `${doc.title} | Starting Point Agency`, description: doc.intro.slice(0, 155) });

  return (
    <div data-testid="legal-page" className="min-h-screen bg-white">
      <header className="bg-navy bg-grid-dark">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-5 sm:px-8">
          <a href="/" data-testid="legal-logo-link" aria-label="Starting Point Agency — home">
            <Logo dark />
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 font-display text-[11px] font-bold tracking-[0.15em] text-white transition-colors hover:border-brand-cyan hover:text-brand-cyan"
          >
            <ArrowLeft className="h-3.5 w-3.5 transition-transform group-hover:-translate-x-0.5" />
            TORNA AL SITO
          </a>
        </div>
        <div className="mx-auto max-w-4xl px-5 pb-14 pt-8 sm:px-8">
          <h1 className="font-display text-4xl font-black tracking-tight text-white sm:text-5xl">{doc.title}</h1>
          <p className="mt-3 font-mono text-[11px] tracking-[0.25em] text-white/40">{doc.updated.toUpperCase()}</p>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-14 sm:px-8">
        <p className="text-lg leading-relaxed text-slate-700">{doc.intro}</p>
        <div className="mt-12 space-y-10">
          {doc.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-xl font-extrabold tracking-tight text-navy">{s.heading}</h2>
              {s.paragraphs.map((p, i) => (
                <p key={i} className="mt-3 text-[15px] leading-relaxed text-slate-600">{p}</p>
              ))}
              {s.list && (
                <ul className="mt-3 space-y-2">
                  {s.list.map((item) => (
                    <li key={item} className="flex items-center gap-3 text-[15px] text-slate-600">
                      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-brand-gradient" aria-hidden="true" />
                      {item}
                    </li>
                  ))}
                </ul>
              )}
              {s.after && <p className="mt-3 text-[15px] leading-relaxed text-slate-600">{s.after}</p>}
            </section>
          ))}
        </div>
      </main>

      <footer className="border-t border-slate-200">
        <div className="mx-auto flex max-w-4xl flex-col gap-2 px-5 py-8 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between sm:px-8">
          <p>© 2026 Starting Point Agency — P.IVA {CONTACT.piva}</p>
          <p>WHERE VISIBILITY STARTS.</p>
        </div>
      </footer>
    </div>
  );
};
